import {CheckinAlreadyExistForUser, NextStepRequired} from "@/domain/autologin/exceptions";

const state = {
    token: false,
    step: null,
    stepData: null,
    picacode: null,
    domain: window.location.hostname,
}

export const getters = {
    token: state => state.token,
    stepData: state => state.stepData,
    step: state => state.step,
    picacode: state => state.picacode,
    privacy: state => state.stepData ? state.stepData.privacy : null,
    skipModalDataCollector: () => !!process.env.VUE_APP_SKIP_MODAL_DATA_COLLECTOR,
    domain: state => state.domain
}


export const mutations = {
    set_token(state, token) {
        state.token = token
    },
    set_step_data(state, data) {
        state.stepData = data
    },
    set_step(state, step) {
        state.step = step
    },
    set_picacode(state, picacode) {
        state.picacode = picacode
    },
}

export const actions = (eventService) => ({
    async completeCheckin({commit, getters}, data) {
        let content_type = 'application/json'
        if (data instanceof FormData) {
            content_type = 'multipart/form-data'
            data.append('platform', 'site')
        } else
            data['platform'] = 'site'

        try {
            const response = await eventService.completeCheckin(getters.token, data, content_type)
            window.vueApp.$bvModal.hide('bv-modal-checkin-maker')
            commit('set_picacode', response.data.picacode)
            return response
        } catch (error) {
            const errorResponse = error && error.response
            if (!errorResponse) throw error

            if (errorResponse.status === 303) {
                commit('set_step_data', errorResponse.data)
                commit('set_token', errorResponse.data.complete_token)
                commit('set_step', errorResponse.data.checkin_step)
                throw new NextStepRequired(errorResponse.data.checkin_step)
            }
            throw error
        }
    },
    async resetStepData({commit}) {
        commit('set_step_data', null)
    },
    async createCheckin({commit, getters}, {picacode, source, tags}) {
        try {
            const response = await eventService.createCheckin(picacode.toUpperCase(), source, tags, getters['domain'])
            window.vueApp.$bvModal.hide('bv-modal-checkin-maker')
            commit('set_picacode', response.data.picacode)
            return response
        } catch (error) {
            const errorResponse = error && error.response
            if (!errorResponse) throw error

            if (errorResponse.status === 303) {
                commit('set_step_data', errorResponse.data)
                commit('set_token', errorResponse.data.complete_token)
                commit('set_step', errorResponse.data.checkin_step)
                throw new NextStepRequired(errorResponse.data.checkin_step)
            } else if (errorResponse.status === 400) {
                const errorCode = errorResponse.data.code
                if (errorCode === 'checkin_exists_for_user')
                    throw new CheckinAlreadyExistForUser(errorResponse.data.error_data.picacode)
                else
                    throw error
            }
            throw error
        }
    },
    openStepModal({getters}) {
        window.vueApp.$bvModal.hide('bv-modal-checkin-maker')
        window.vueApp.$bvModal.hide('modal-precheckindatacollector')
        window.vueApp.$bvModal.hide('modal-precheckinfacerecognition')
        window.vueApp.$bvModal.hide('modal-checkin-options')

        setTimeout(() => {
            if (getters.step === 'data_collector') {
                if (getters.skipModalDataCollector) {
                    window.location = getters.stepData.form_url
                } else {
                    window.vueApp.$bvModal.show('modal-precheckindatacollector')
                }
            } else if (getters.step === 'face_recognition'){
                window.vueApp.$bvModal.show('modal-precheckinfacerecognition')
            } else if (getters.step === 'option_selector')
                window.vueApp.$bvModal.show('modal-checkin-options')
        }, 500)
    },
    // eslint-disable-next-line no-unused-vars
    async uploadSelfie({commit}, {id, payload}) {
        return await eventService.uploadSelfie(id, payload)
    },
    openAddSelfieStep({commit, dispatch}, data) {
        commit('set_step_data', data)
        commit('set_step', 'face_recognition')
        dispatch('openStepModal')
    }
})

export default eventService => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(eventService)
})
